<script>
export default {
  components: {},
  beforeCreate() {
    document.body.className = 'login'
  },
}
</script>

<template>
  <div :class="$style.layoutContainer" class="d-flex">
    <div :class="$style.container">
      <div :class="$style.containerBody">
        <slot />
      </div>
    </div>

    <div :class="$style.brandContainer">
      <img :class="$style.brandLogo" src="@assets/images/mottocenter-new-logo-white.png" alt="Logo" />
      <h2 :class="$style.brandSlogan">Tools to help you every step of the way.</h2>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  display: flex;
  width: 57.4%;
  min-height: 100vh;
  background: $white;
  border-radius: 0 56px 56px 0;
}

.containerBody {
  display: flex;
  width: 100%;
  margin-top: 10%;
  margin-bottom: 10%;

  form {
    align-self: center;
    width: 302px;
    padding: 0;
    margin-top: -4%;
    margin-right: auto;
    margin-left: auto;

    button {
      width: 302px;
    }

    a {
      display: block;
      width: fit-content;
      margin: 40px 0 56px auto;
    }
  }
}

.brandContainer {
  align-self: center;
  margin: -3% auto 0 auto;
}

.brandLogo {
  @media (max-width: $lg-breakpoint) {
    width: 250px;
    height: 47px;
  }

  display: block;
  width: 384px;
  height: 72px;
  margin: auto auto 72px auto;
  text-align: center;
}

.brandSlogan {
  margin-right: 8px;
  color: $white;
  text-align: center;
}

@media screen and (max-width: $lg-breakpoint) {
  .layoutContainer {
    flex-direction: column-reverse;
  }
  .container {
    display: block;
    width: 100%;
    margin-top: 20px;
    border-radius: 32px 32px 0 0;
  }

  .containerBody {
    margin-top: 48px;

    form {
      width: 269px;
      margin-top: 0;

      button {
        width: 269px;
      }
    }
  }

  .brandContainer {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 48px auto;
  }

  .brandLogo {
    width: 250px;
    margin: 0 auto 32px auto;
  }

  .brandSlogan {
    font-size: 14px;
  }
}
</style>
